import * as types from 'constants/ActionTypes';
import { custom } from 'utils/Api';

export const requestBonuses = () => ({
  type: types.REQUEST_BONUSES,
});

export const requestBonusesSuccess = bonuses => ({
  type: types.REQUEST_BONUSES_SUCCESS,
  bonuses,
});

export const requestBonusesFailure = error => ({
  type: types.REQUEST_BONUSES_FAILURE,
  error,
});

export const fetchBonuses = employeeDetailId =>
  (dispatch, getState) => {
    dispatch(requestBonuses());
    const {
      loginReducer: { user: { token } },
    } = getState();

    const config = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      url: '/kjarni/api/v2/EmployeeDetailBasicPays',
      params: {
        $filter: `EmployeeDetailID eq ${employeeDetailId}`,
      },
    };

    return custom(config)
      .then(({ data }) => {
        dispatch(requestBonusesSuccess(data.value));
      })
      .catch(err => dispatch(requestBonusesFailure(err)));
  };



// WEBPACK FOOTER //
// ./src/actions/EmployeeBonuses.js